import Popconfirm from 'bee-popconfirm'

export default Popconfirm
